import { useSelector } from 'react-redux';
import {companyFeaturesConstants} from '../constants';

const featureName = companyFeaturesConstants.TREEZOR_DISABLED;

export const useIsTreezorEnabled = () => {
  const isLoaded = useSelector(state => state.company?.features?.loaded || false);
  const features = useSelector(state => state.company?.features?.data || []);
  const isActive = features.find(f => f.feature === featureName)?.is_active;
  return isLoaded && !isActive;
};
